import {meService} from "../services/me";
import {residentContextService} from "../services/resident-context";
import {useResidentContextStore} from "../store/resident-context";
import {useResidentHouseholdForbiddenPendingStore} from "../store/resident-household-forbidden-pending";
import {toast} from "../hooks/use-toast";

const FORBIDDEN_MESSAGE = "You do not have access to this household.";
const NO_ACCESS_FALLBACK = "You no longer have access to any units on your account.";

function navigateResidentToHome(): void {
  if (typeof window === "undefined") return;
  const hashRoute = window.location.hash.replace(/^#/, "") || "/";
  if (hashRoute === "/" || hashRoute === "") return;
  window.location.hash = "#/";
}

export function handleResidentContextHouseholdForbidden(message?: string): void {
  const store = useResidentHouseholdForbiddenPendingStore.getState();
  if (store.pending) return;

  const forbiddenHouseholdId = useResidentContextStore.getState().selectedHouseholdId;
  const resolvedMessage = message?.trim() || FORBIDDEN_MESSAGE;

  store.queuePending({
    message: resolvedMessage,
    forbiddenHouseholdId,
  });
}

export async function acknowledgeResidentHouseholdForbiddenRecovery(): Promise<void> {
  const store = useResidentHouseholdForbiddenPendingStore.getState();
  const pending = store.pending;
  if (!pending || store.isRecovering) return;

  store.setRecovering(true);

  try {
    await meService.getMe();
    const recovered = residentContextService.recoverFromForbiddenHousehold(
      pending.forbiddenHouseholdId,
    );

    if (recovered) {
      navigateResidentToHome();
      store.clearPending();
      return;
    }

    toast.error(pending.message.trim() || NO_ACCESS_FALLBACK);
    store.clearPending();
  } catch {
    toast.error(NO_ACCESS_FALLBACK);
    store.setRecovering(false);
  }
}
